export default "__VITE_ASSET__Cl$kvoiO__ 640w, __VITE_ASSET__BYVrK1Wf__ 1024w, __VITE_ASSET__rwEAI$bD__ 1280w";